<template>
  <main id="main-container">
    <!-- NEW ALARM FORM -->
    <Hero title="Alarmas" page="alarmas" />
    <div class="content">
      <div class="row">
        <div class="col-sm-12">
          <Card v-if="$store.state.devices.length > 0">
            <template v-slot:header>
              <h4 class="card-title">Crear nueva regla para alarmas</h4>
            </template>

            <form class="row" @submit.prevent="createNewRule()">
              <div class="col-6 col-md-3">
                <label class="form-label">Variable</label>
                <select
                  required
                  class="form-select mt-2"
                  v-model="selectedWidgetIndex"
                >
                  <option value="777">Estado (dispositivo)</option>
                  <option
                    v-for="(widget, index) in $store.state.selectedDevice
                      .template.widgets"
                    v-bind:key="index"
                    :value="index"
                  >
                    {{ widget.variableFullName }}
                  </option>
                </select>
              </div>

              <div class="col-6 col-md-3">
                <label class="form-label">Condicion</label>
                <select
                  required
                  class="form-select mt-2"
                  v-model="newRule.condition"
                > 
                  <template v-if="selectedWidgetIndex != 777">
                    <option value=">" label="Mayor que "></option>
                    <option value="=" label="Igual a "></option>
                    <option value=">=" label="Mayor o igual "></option>
                    <option value="<" label="Menor que "></option>
                    <option value="<=" label="Menor o igual"></option>
                    <option value="!=" label="Distinto de "></option>
                  </template>
                  <template v-else>
                    <option value="connected" label="Conexion"></option>
                    <option value="disconnected" label="Desconexion"></option>
                  </template>
                </select>
              </div>

              <div v-if="newRule.variable != 777" class="col-6 col-md-3 mt-2">
                <label class="form-label">Valor</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="newRule.value"
                  required
                />
              </div>

              <div class="col-6 col-md-3 mt-2">
                <label class="form-label">Tiempo entre Alertas</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="newRule.triggerTime"
                  required
                  min="10"
                />
              </div>
              <br /><br />
              <div class="row pull-right">
                <div class="col-12">
                  <button
                    type="submit"
                    class="mt-4 btn btn-info pull-right"
                    :disabled="$store.state.devices.length == 0"
                  >
                    Agregar Alarma
                  </button>
                </div>
              </div>
            </form>
          </Card>
          <Card v-else>
            Necesitas seleccionar un dispositivo para Activar las alarmas
          </Card>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <Card>
            <template v-slot:header>
              <h3 class="card-title">Tipo de Notificacion</h3>
            </template>

            <div>
              <div
                v-for="(ntf, id) in Object.keys(ntfn)"
                v-bind:key="id"
                class="form-check form-switch form-check-inline"
              >
                <label class="form-label" >
                  {{capitalizeString(ntf)
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="ntfn[ntf].active"
                  @click="updateNotification(ntf)"
                />
              </div>
            </div>
          </Card>
        </div>
      </div>

      <!-- TELGRAM ALARMS -->
      <div class="row">
        <div class="col-sm-12">
          <Card>
            <template v-slot:header>
              <a target="_blank" :href="tlg_bot_link">
                <h3 class="card-title">
                  <span class="tim-icons icon-send"></span> Telegram BOT
                </h3>
                <span>Link bot: {{ tlg_bot_link }} </span>
              </a>
              <h4 v-if="telegram_token">Token : {{ telegram_token }}</h4>
              <p v-else></p>

              <button @click="updateTelegranToken()" class="btn btn-info">
                Generar
              </button>

              <a
                style="margin-left: 10px;"
                :href="tlg_bot_link"
                target="_blank"
                v-if="telegram_token != null"
              >
                <button
                  @click="copyMessage"
                  class="btn btn-success"
                >
                  Ir y copiar
                </button>
              </a>
            </template>
          </Card>
        </div>
      </div>

      <!-- ALARMS TABLE -->
      <div class="row" v-if="$store.state.devices.length > 0">
        <div class="col-sm-12">
          <Card>
            <template v-slot:header>
              <h4 class="card-title">Reglas de alarmas</h4>
            </template>

            <div
              class="table-responsive"
              v-if="$store.state.selectedDevice.alarmRules.length > 0"
            >
              <table class="table table-bordered table-striped table-vcenter">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Variable</th>
                    <th>Variable Id</th>
                    <th>Condicion</th>
                    <th>Valor</th>
                    <th class="mb-1"><span>Tiempo Entre</span><br><span> Alertas (Minutos)</span></th>
                    <th>Nro Alertas</th>
                    <th class="text-center" style="width: 100px">Acciones</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(row, index) in $store.state.selectedDevice
                      .alarmRules"
                    v-bind:key="index"
                  >
                    <td>{{ index }}</td>
                    <td>{{ row.variableFullName }}</td>
                    <td>{{ row.variable }}</td>
                    <td>{{ row.condition }}</td>
                    <td>{{ row.value }}</td>
                    <td>{{ row.triggerTime }}</td>
                    <td>{{ row.counter }}</td>
                    <td>
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input mt-2"
                          v-model="row.status"
                          type="checkbox"
                          @click="updateStatusRule(row)"
                        />
                        <button
                          type="button"
                          class="btn btn-sm btn-alt-danger js-bs-tooltip-enabled"
                          @click="deleteRule(row)"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4 v-else class="card-title">No hay reglas de Alarmas</h4>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
} from "firebase/auth";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { messaging } from "@/firebaseConfig";
import axios from "@/axios";
import useApp from "@/composables/useApp";
export default {
  components: {
  },
  data() {
    return {
      ntfn: {
        push: { active: false },
        email: { active: false },
        telegram: { active: false },
      },
      axiosHeaders: {
        headers: {
          token: this.$store.state.auth.token,
        },
      },
      tlg_bot_link: `https://t.me/${process.env.VUE_APP_TLG_BOT}`,
      alarmRules: [],
      selectedWidgetIndex: null,
      newRule: {
        
        dId: null,
        deviceName: null,
        status: true,
        variableFullName: null,
        variable: null,
        value: null,
        condition: null,
        triggerTime: 10,
      },
      telegram_token: null,
      tlg_token_command: "",
    };
  },
  mounted() {
    const { ToastMsg, ToastMsgError, ToastMsgInfo, ToastMsgWarning } = useApp();
    this.ToastMsg = ToastMsg;
    this.ToastMsgError = ToastMsgError;
    this.ToastMsgInfo = ToastMsgInfo;
    this.ToastMsgWarning = ToastMsgWarning;
    this.$store.dispatch("getPushToken");
    this.getNotificationStatus();
    const messaging = getMessaging();
    onMessage(messaging, payload => {
      console.log("Message on client ", payload);
    });
  },

  methods: {
    copyMessage() {
      this.$copyText(this.tlg_token_command)
    },
    capitalizeString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    async getNotificationStatus() {
      axios.get("/alarm/notification-status", this.axiosHeaders).then((res) => {
        if (res.data.status == "success") {
          this.ntfn = res.data.data;
          if (this.$store.state.push) {
            this.ntfn.push.active = true;
          } else {
            this.ntfn.push.active = false;
          }
        } else {
          this.ToastMsgError("Error al Actualizar Notificaciones !", "bell", 5000)          
        }
      });
    },

    async updateNotification(option) {
      const conteoActivos = Object.values(this.ntfn).reduce(
        (contador, valor) => {
          if (valor.active) {
            return contador + 1;
          } else {
            return contador;
          }
        },
        0
      );

      if (this.ntfn[option].active == true && conteoActivos < 2) {
        alert("No puedes Desactivar todos los metodos de Notificacion !");
        return;
      }

      let data = {
        type: option,
        value: !this.ntfn[option].active,
      };

      if (option == "push" && data.value) {
        this.ntfn.push.active = false
        this.ToastMsgInfo("Notificaciones Push No disponibles !", "bell", 5000)
        return 
        const token = await this.authenticate();
        if (token) {
          data.token = token;
          this.$store.commit("setPushToken", data);
          
        } else {
          this.ToastMsgError(
            "Error ! Notificaciones No Activadas en el Navegador",
            "server",
            5000
          );
          return;
        }
      }

      if (option == "push" && !data.value) {
        return
        data.token = this.$store.state.push.token;
        this.$store.commit("setPushNull");
      }

      axios
        .post("/alarm/notification-status", data, this.axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsg("Estado de Notificaciones Actualizado !", "bell", 5000)
            this.ntfn = res.data.data;
            console.log(this.ntfn);
          } else {
            this.ToastMsgError(
              "Error al Actualizar Notificaciones !",
              "server",
              5000
            );
          }
        });
    },

    async authenticate() {
      try {
        await signInAnonymously(getAuth());
        let token = await getToken(messaging, {
          vapidKey: process.env.VUE_APP_VAPIDKEY,          
        });
        return token;
      } catch (err){
        console.log(err)
        return false;
      }
    },

    updateTelegranToken() {
      axios
        .post("/telegram-token", {}, this.axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsg(
              "Completado! Telegram Token Generado",
              "server",
              5000
            );
            this.tlg_token_command = `/on ${res.data.tlg_token}`;
            this.telegram_token = res.data.tlg_token;
            return;
          }
        })
        .catch((err) => {
          this.ToastMsgError("Error Api server", "server", 5000);
          console.log(err);
          return;
        });
    },

    deleteRule(rule) {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
        params: {
          emqxRuleId: rule.emqxRuleId,
        },
      };

      axios
        .delete("/alarm-rule", axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsgWarning("Completado! Se ha borrado regla de alarma", "bell", 5000)
            this.$store.dispatch("getDevices");
            return;
          }
        })
        .catch((e) => {
          this.ToastMsgError("Error Api server", "server", 5000)
          console.log(e);
          return;
        });
    },

    updateStatusRule(rule) {
      var ruleCopy = JSON.parse(JSON.stringify(rule));

      ruleCopy.status = !ruleCopy.status;

      const toSend = { rule: ruleCopy };

      axios
        .put("/alarm-rule", toSend, this.axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsg(
              `Alarma [${rule.variableFullName}] Actualizada !`,
              "bell",
              5000
            );
            this.$store.dispatch("getDevices");

            return;
          }
        })
        .catch((e) => {
          this.ToastMsgError("Error Api Server", "server", 5000);
          console.log(e);
          return;
        });
    },

    createNewRule() {
      if (this.selectedWidgetIndex == null) return
      if (this.newRule.condition == null) return
      if (this.newRule.value == null) return 

      if (this.newRule.triggerTime == null || this.newRule.triggerTime < 10) {
        this.ToastMsgInfo("El tiempo debe ser mayor a 10 min", "user", 5000)
        return;
      }

      let variable = null
      let variableFullName = null
      const widget = this.$store.state.selectedDevice.template.widgets[this.selectedWidgetIndex]
      if (this.selectedWidgetIndex == 777) {
        variable = "connected"
        variableFullName = "Estado(dispositivo)"
      } else {
        variable = widget.variable;
        variableFullName = widget.variableFullName
      }    
      
      this.newRule.dId = this.$store.state.selectedDevice.dId;
      this.newRule.deviceName = this.$store.state.selectedDevice.name;
      this.newRule.variableFullName = variableFullName        
      this.newRule.variable = variable;

      var toSend = {
        newRule: this.newRule,
      };

      axios
        .post("/alarm-rule", toSend, this.axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.newRule.variable = null;
            this.newRule.condition = null;
            this.newRule.value = null;
            this.newRule.triggerTime = 10;
            this.selectedWidgetIndex = null;
            this.ToastMsg(`Alarma Creada en [${this.newRule.variableFullName}]`, "bell", 5000)
            this.$store.dispatch("getDevices");

            return;
          }
        })
        .catch((e) => {
          this.ToastMsgError("Error Api server", "server", 5000)
          return;
        });
    },
  },
};
</script>
